var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighestMarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-groups_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "groups_4",
    "data-name": "groups \\u2013 4",
    clipPath: "url(#clip-groups_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 255.5,
    cy: 255.5,
    r: 255.5,
    transform: "translate(1 1)",
    fill: "rgba(0,198,255,0.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-up",
    "data-name": "Icon awesome-arrow-up",
    d: "M15.319,133.632,3.994,122.307a12.193,12.193,0,0,1,0-17.294l99.119-99.17a12.193,12.193,0,0,1,17.294,0l99.119,99.119a12.193,12.193,0,0,1,0,17.294L208.2,133.581a12.257,12.257,0,0,1-17.5-.2l-58.513-61.42V218.569a12.214,12.214,0,0,1-12.243,12.243H103.623A12.214,12.214,0,0,1,91.38,218.569V71.956L32.816,133.428a12.169,12.169,0,0,1-17.5.2Z",
    transform: "translate(144.602 139.755)",
    fill: "#0093be"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighestMarks);
export default __webpack_public_path__ + "static/media/highest-marks.77645711.svg";
export { ForwardRef as ReactComponent };